<template>
  <div class="auth-page-scroll-container">
    <div class="auth-page-wrapper gap-row-lg">
      <div class="auth-page-top-header gap-row-sm">
        <img src="/icons/qr-uikit-black-logo.svg" alt="" />
        <div class="qrw-label-sm bold v1-grey-6-color">Admin Panel</div>
      </div>

      <div class="auth-page-main-content gap-row-lg">
        <div
          class="
            auth-page-text-header
            w-100
            qrw-heading-md
            v1-grey-10-color
          "
        >
          <slot name="header" />
        </div>

        <slot />
      </div>
    </div>

     <img @click="changeLocale" class="locale-image" :src="`/flags/${this.$i18n.locale}.png`" />
  </div>
</template>

<script>
import moment from 'moment'

export default {

  //TODO: DRY! Move it to single place
  methods: {
    changeLocale() {
      let index = this.availableLocales.findIndex(
        (l) => l == this.$i18n.locale
      );

      let locale_to_set = "ua";

      if (index !== -1) {
        index++;
        if (index >= this.availableLocales.length) index = 0;

        locale_to_set = this.availableLocales[index];
      }

      this.$i18n.locale = locale_to_set;
      if (locale_to_set == "ua") {
        moment.locale("uk");
      } else {
        moment.locale(locale_to_set);
      }
      window.localStorage.setItem("locale", locale_to_set);
    },
    
  },
  computed: {
    availableLocales: () => ["ua", "ru", "en"],
  }
};
</script>

<style scoped>
.auth-page-top-header img {
  width: 32px;
  height: 32px;
  max-height: 32px;
  max-width: 32px;
  min-width: 32px;
  min-height: 32px;
}

.auth-page-top-header {
  justify-content: center;
  width: 100%;
  align-items: center;
  text-align: center;
}

.auth-page-text-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.auth-page-content {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
  width: 100%;
}

.auth-page-main-content {
  display: flex;
  /* justify-content: center; */
  align-items: center;

  height: fit-content;
  min-height: 621px;

  width: 320px;
}

.auth-page-wrapper {
  display: flex;
  width: 100%;
  align-items: center;

  padding: 80px 0;

  height: fit-content;
}

.locale-image {
  width: 24px;
  height: 24px;
  cursor: pointer;

  max-width: 24px;
  min-height: 24px;

  position: absolute;

  top: 24px;
  right: 24px;
}
</style>